import { useEffect, useState } from 'react';

/**
 * The mobile band from the viewport contract: phone-width, *or* a coarse-pointer
 * device that is short enough to be a landscape phone (844x390 -- 844px wide, so
 * a width-only query would hand it the desktop layout at 390px of height).
 */
export const MOBILE_QUERY = '(max-width: 639px), (pointer: coarse) and (max-height: 500px)';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
